import { UserInfo } from '@models/user-info.model';

 
export namespace AppActions {
  export class setUserInfo {
    static readonly type = '[User] Set User Info';

    constructor(public payload: UserInfo) {
    }
  }
}
